let newFn2 = () => {
  console.log(`a`);
};
newFn2();